import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import { setNavCommunity, setSelectedLayout, setDrawerIframe } from "Actions";
import { changeNavCommunity } from "Thunks";

import { getUserLayouts } from "Utils";

import { selectUserCommunities, selectNavCommunity } from "Selectors";

export class Layouts extends Component {
  static propTypes = {
    setNavCommunity: PropTypes.func
  };

  handleSelectCommunity = community => {
    const { setNavCommunity, changeNavCommunity } = this.props;
    setNavCommunity(community);
    changeNavCommunity(community.id);
    setTimeout(() => {
      window.location.reload(true);
    }, 200);
  };

  selectLayout(index) {
    const {
      setSelectedLayout,
      setDrawerIframe,
      blocs,
      user,
      navCommunity
    } = this.props;
    setSelectedLayout(index);
    const layouts = getUserLayouts(user, blocs, navCommunity.id);
    if (layouts && layouts.length > index) {
      setDrawerIframe(layouts[index].config[0].url);
    }
  }

  renderLayouts() {
    const { blocs, user, navCommunity } = this.props;

    if (!blocs || blocs.length === 0) {
      return null;
    }
    const layouts = getUserLayouts(user, blocs, navCommunity.id);

    const layoutsBlock = layouts.map((bloc, index) => {
      return (
        <li className="menu__sub-child" key={`bloc-${index}`}>
          <a activeClassName="active" onClick={() => this.selectLayout(index)}>
            {bloc.name}
          </a>
        </li>
      );
    });

    return (
      <div className="menu__dropdown">
        <ul>{layoutsBlock}</ul>
      </div>
    );
  }

  getLayoutDisplayName(blocs, selectedLayout) {
    return blocs.length > selectedLayout ? blocs[selectedLayout].name : "";
  }

  render() {
    const { blocs, selectedLayout, user, navCommunity } = this.props;

    const layouts = getUserLayouts(user, blocs, navCommunity.id);
    if (!layouts || layouts.length < 2) {
      return null;
    }
    return (
      <ul className="menu">
        <li className="menu__has-child menu__community">
          <a activeClassName="active" className="menu__link">
            <span>{this.getLayoutDisplayName(layouts, selectedLayout)}</span>
            <i className="icon icon-arrow-down" />
          </a>
          {this.renderLayouts()}
        </li>
      </ul>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  user: state.auth.user,
  routing: state.routing,
  blocs: state.hub.blocs,
  selectedLayout: state.auth.selectedLayout,
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  setSelectedLayout: index => dispatch(setSelectedLayout(index)),
  setDrawerIframe: url => dispatch(setDrawerIframe(url))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layouts);



// WEBPACK FOOTER //
// ./src/components/Menu/Layouts.js